<template>
  <div class="repeat-box">
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <img src="../assets/img/defaultpage_img_null@2x.png" alt="" class="repeat-img">
    <p class="repeat-desc">{{ decodeURI(msg) }}</p>
  </div>
</template>

<script>

export default {
  data() {
    return {
      msg: ''
    };
  },
  mounted() {
    this.msg = this.$route.query.msg || '--'
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  }
}

</script>

<style lang="less" scoped>
::v-deep {

  .van-icon.van-icon-arrow-left.van-nav-bar__arrow,
  .van-nav-bar__text {
    color: #000;
  }
}


.repeat-box {
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 0 0;
  background-color: #fff;
  text-align: center;
  color: #999;

  img {
    display: inline-block;
    width: 240px;
  }
}
</style>
